import React, { useEffect, useState } from 'react';
import './stylesheet.scss';
import { isArray, isEmpty } from 'lodash';
import { queryStringToObject } from '../../../utils/http';

const GoToPage = ({ action, min = 1, max, placeholder }) => {
  const [value, setValue] = useState('');
  const [params, setParams] = useState([]);
  const queryStringParams = queryStringToObject(window.location.search);

  useEffect(() => {
    if (!isEmpty(queryStringParams)) {
      const p = [];
      Object.entries(queryStringParams).forEach(([k, v]) => {
        if (isArray(v)) {
          v.forEach(v1 => {
            p.push([`${k}[]`, v1]);
          });
        } else {
          p.push([k, v]);
        }
      });

      setParams(p);
    }
  }, []);

  return (
    <div className="common-go-to-page">
      <form id="formPagination" name="formPagination" method="get" action={action}>
        <div className="input-group">
          {params.map(([n, v]) => (
            <input key={n} type="hidden" name={n} value={v} />
          ))}
          <input name="p" type="number" min={min} max={max} value={value} onChange={e => setValue(e.target.value)} className="form-control input-sm" placeholder={placeholder} />
          <span className="input-group-btn">
            <button type="submit" className="btn btn-default btn-sm background background-gray-darker font font-white">
              Ok
            </button>
          </span>
        </div>
      </form>
    </div>
  );
};

export default GoToPage;
